import { Component } from "@angular/core";
import { NgIf } from "@angular/common";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { GroupCellRendererParams, IRowNode } from "ag-grid-community";

interface GroupRowParams extends GroupCellRendererParams {
  flagCodes: Record<string, string>;
}

@Component({
  standalone: true,
  imports: [NgIf],
  template: ` <div class="row">
    <img
      *ngIf="flagCode"
      class="flag"
      border="0"
      width="20"
      height="15"
      [src]="flagCodeImg"
    />
    <span class="groupTitle">{{ node.key }}</span>
  </div>`,
  styles: [
    `
      .row {
        display: inline-block;
      }

      .groupTitle {
        font-size: 16px;
        font-weight: bold;
      }

      .medal {
        margin: 0 5px;
      }

      .gold {
        color: #e4ab11;
      }

      .silver {
        color: #bbb4bb;
      }

      .bronze {
        color: #be9088;
      }

      .flag {
        margin: 0 4px;
        position: relative;
        top: 2px;
      }
    `,
  ],
})
export class GroupRowInnerRenderer implements ICellRendererAngularComp {
  public flagCodeImg!: string;
  public flagCode!: any;
  public node!: IRowNode;
  agInit(params: GroupRowParams | any): void {
    this.node = params.node;
    this.flagCode = params?.node?.data?.code;
  }

  refresh(): boolean {
    return false;
  }
}
